module.exports = __webpack_public_path__ + "static/media/PU_svg_H_ESP.f4a0e1d8.svg";